import type { ConfigTreeNode } from '~/settings/components/ConfigurationsPage/types';

export function getTreeItem(
  itemId: string,
  tree: ConfigTreeNode | null
): ConfigTreeNode | undefined {
  if (!tree) {
    return undefined;
  }

  // Virtual root doesn't need data
  if (itemId === 'root') {
    return undefined;
  }

  function findNodeInTree(node: ConfigTreeNode): ConfigTreeNode | undefined {
    if (node.id === itemId) {
      return node;
    }
    if (node.children) {
      for (const child of node.children) {
        const found = findNodeInTree(child);
        if (found) {
          return found;
        }
      }
    }
    return undefined;
  }

  return findNodeInTree(tree);
}

export function getTreeChildrenNodes(itemId: string, tree: ConfigTreeNode | null): string[] {
  if (!tree) {
    return [];
  }

  // Virtual root has the main tree root as its child
  if (itemId === 'root') {
    return tree ? [tree.id] : [];
  }

  const node = getTreeItem(itemId, tree);
  if (node && node.children) {
    return node.children.map((child) => child.id);
  }

  return [];
}
